<script>
import Section from '../../components/PageSection'
import Ajouter from '../../components/PageForm'
import Modale from '../../components/Modale'
import ModalYesNo from "../../components/ModalYesNo"

export default {
  name: 'Listes',
  components: {
    Section,
    Ajouter,
    Modale,
    ModalYesNo,
  },
  data(){
    return{
      phases: [[],[],[]], // 0:études  1:chantier  2:missions
      isModaleVisible_delete: false,
      modaleInfos: {},
      nonFact: [],  //Tâches non facturables
      absences: [], //Absences
      frais: [],    //Frais
    }
  },
  mounted(){
    //Chargement des phases
    this.$axios.get('phaseLabels/get0/' + this.$store.state.auth.currentAgence._id)
      .then(response => {
            this.$set(this.phases, 0, response.data);  //L'équivalent de "this.phases[0] = currentPhases", mais qui permet de conserver la réactivité.
            // Pour les mêmes raison, utiliser la fonction suivante pour mettre à jour : this.phases.splice(indexOfItem, 1, newValue)
          })
    this.$axios.get('phaseLabels/get1/' + this.$store.state.auth.currentAgence._id)
      .then(response => {
            this.$set(this.phases, 1, response.data);  //L'équivalent de "this.phases[0] = currentPhases", mais qui permet de conserver la réactivité.
            // Pour les mêmes raison, utiliser la fonction suivante pour mettre à jour : this.phases.splice(indexOfItem, 1, newValue)
          })
    this.$axios.get('phaseLabels/get2/' + this.$store.state.auth.currentAgence._id)
      .then(response => {
            this.$set(this.phases, 2, response.data);  //L'équivalent de "this.phases[0] = currentPhases", mais qui permet de conserver la réactivité.
            // Pour les mêmes raison, utiliser la fonction suivante pour mettre à jour : this.phases.splice(indexOfItem, 1, newValue)
          })

    //Chargement des tâches
    this.$axios.get('nonFact/unflagged/' + this.$store.state.auth.currentAgence._id)
    .then(response => {
      this.nonFact = response.data      
    })
    .catch(err => {
      console.log(err)
    })

    //Chargement des absences
    this.$axios.get('absences/unflagged/' + this.$store.state.auth.currentAgence._id)
    .then(response => {
      this.absences = response.data      
    })
    .catch(err => {
      console.log(err)
    })

    //Chargement des frais
    this.$axios.get('frais/unflagged/' + this.$store.state.auth.currentAgence._id)
    .then(response => {
      this.frais = response.data      
    })
    .catch(err => {
      console.log(err)
    })


  },
  methods: {
    //-------------------------------
    //            Phases
    //-------------------------------
    closeModaleDelete(){
      this.isModaleVisible_delete = false;
      this.modaleInfos = {};
    },
    showModaleDelete(e, _id){
      this.modaleInfos._id = _id

      switch (e){
        case 'phase':
          this.modaleInfos.type = e
          this.modaleInfos.title = "Suppression de phase"
          break;
        case 'tache':
          this.modaleInfos.type = e
          this.modaleInfos.title = "Suppression de tache non facturable"
          break;
        case 'absence':
          this.modaleInfos.type = e
          this.modaleInfos.title = "Suppression d'absence"
          break;
        case 'frais':
          this.modaleInfos.type = e
          this.modaleInfos.title = "Suppression de frais"
          break;
      }
      this.isModaleVisible_delete = true;
    },
    //-------------------------------
    //            Phases
    //-------------------------------
    addPhase(payload, i) { //Objectif : rajouter une nouvelle phase dans l'objet du client et la BDD
      //Vérifier qu'il y a bien une ID d'agence dans le local store, sinon je ne saurai pas à quelle agence relier cette nouvelle phase.
      //Vérifier qu'il y ai bien une nouvelle valeur à ajouter
      if (this.$store.state.auth.currentAgence._id  &&  payload[0] != ""){
        //Je commence par calculer à quel rang je place la future phase par rapport à la plus grande phase existante, si elle existe
        let actualRank
        if (this.phases[i].length > 0){
          actualRank = this.phases[i].length - 1  
        } else {
          actualRank = -1
        }      

        //Je défini ma phase
        let phase = {
          agenceId: this.$store.state.auth.currentAgence._id,
          name: payload[0],
          type: i,
          rank: actualRank +1,
        };

        this.$axios.post('phaseLabels/register', phase)
        .then(response => {
            console.log(response.data.message)
            //J'ajoute l'Id reçu de serveur à mon objet Phase en local pour l'ajouter à mon client et pouvoir la manipuler
            phase._id = response.data.phaseId;
            this.phases[i].push(phase);
          })
          .catch(e => {
            console.log(e);
          });
      } else {
        console.log("Pas d'ID d'agence en local, impossible de savoir à quelle ID relier ces nouvelles données.")
      }
    },
    async movePhase(phase, i, sens){
      //Si on cherche à faire descendre la phase (le rang augmente) et qu'elle n'est pas déjà la dernière
      let actualRank = phase.rank;
      if (sens > 0   &&   phase.rank < this.phases[i].length -1){
        //La phase suivante perd un rang, donc vient au rang actuel
        await this.$axios.put('phaseLabels/' + this.phases[i][actualRank + 1]._id, {rank: actualRank})
          .then(response => {
              console.log(response.data.message);
              //Je met à jour la phase dans this.phases du client
              this.phases[i][actualRank + 1].rank = actualRank;
            })
            .catch(e => {
              console.log(e);
            });

        //Et cette phase prend un rang
        await this.$axios.put('phaseLabels/' + phase._id, {rank: actualRank + 1})
          .then(response => {
              console.log(response.data.message);
              this.phases[i][actualRank].rank = actualRank + 1;
            })
            .catch(e => {
              console.log(e);
            });
        

        //Pour finir, je range le client dans l'ordre
        this.phases[i].sort((a,b) => (a.rank > b.rank) ? 1 : ((b.rank > a.rank) ? -1 : 0));


      //Si on cherche à la faire monter et qu'elle n'est pas déjà la première
      } else if (sens < 0   &&   phase.rank > 0){
        //La phase précedente prend un rang, donc vient au rang actuel
        await this.$axios.put('phaseLabels/' + this.phases[i][actualRank - 1]._id, {rank: actualRank})
          .then(response => {
              console.log(response.data.message);
              //Je met à jour la phase dans this.phases du client
              this.phases[i][actualRank - 1].rank = actualRank;
            })
            .catch(e => {
              console.log(e);
            });

        //Et cette phase perd un rang
        await this.$axios.put('phaseLabels/' + phase._id, {rank: actualRank - 1})
          .then(response => {
              console.log(response.data.message);
              this.phases[i][actualRank].rank = actualRank - 1;
            })
            .catch(e => {
              console.log(e);
            });
        

        //Pour finir, je range le client dans l'ordre
        this.phases[i].sort((a,b) => (a.rank > b.rank) ? 1 : ((b.rank > a.rank) ? -1 : 0));
      }
    },
    changePhase(newName, phaseId){
      console.log(phaseId + " : " + newName);
      this.$axios.put('phaseLabels/' + phaseId, {name: newName})
          .then(response => {
              console.log(response.data.message);
            })
    },
    deletePhase(_Id){
      this.$axios.put('phaseLabels/flagDeleted/' + _Id)
      .then(response => {
        console.log(response.data.message);
        for (let item of this.phases){
          let index = item.findIndex(e => e._id == _Id)
          if (index >= 0){
            item.splice(index, 1)
          }
        }
        this.closeModaleDelete()
      })
    },

    //-------------------------------
    //            nonFact
    //-------------------------------
    addTache(payload){
      //Vérifier qu'il y a bien une ID d'agence dans le local store, sinon je ne saurai pas à quelle agence relier cette nouvelle tache.
      //Vérifier qu'il y ai bien une nouvelle valeur à ajouter
  
      if (this.$store.state.auth.currentAgence._id  &&  payload[0] != ""){
        //Je commence par calculer à quel rang je place la future tache par rapport à la plus grande tache existante, si elle existe
        let actualRank
        if (this.nonFact.length > 0){
          actualRank = this.nonFact.length - 1  
        } else {
          actualRank = -1
        }      

        //Je défini ma nonFact
        let tache = {
          agenceId: this.$store.state.auth.currentAgence._id,
          name: payload[0],
          rank: actualRank + 1,
          //type: 1, //1: tache | 2: absence
        };

        this.$axios.post('nonFact/register', tache)
        .then(response => {
          console.log(response.data.message)
          //J'ajoute l'Id reçu de serveur à mon objet tache en local pour l'ajouter à mon client et pouvoir la manipuler
          tache._id = response.data.tacheId;
          this.nonFact.push(tache);
        })
        .catch(e => {
          console.log(e);
        });

      } else {
        console.log("Pas d'ID d'agence en local, impossible de savoir à quelle ID relier ces nouvelles données.")
      }
    },
    async moveTache(tache, sens){
      //Si on cherche à faire descendre la tache (le rang augmente) et qu'elle n'est pas déjà la dernière
      let actualRank = tache.rank;
      if (sens > 0   &&   tache.rank < this.nonFact.length -1){
        //La tache suivante perd un rang, donc vient au rang actuel
        await this.$axios.put('nonFact/' + this.nonFact[actualRank + 1]._id, {rank: actualRank})
          .then(response => {
              console.log(response.data.message);
              //Je met à jour la tache dans this.nonFact du client
              this.nonFact[actualRank + 1].rank = actualRank;
            })
            .catch(e => {
              console.log(e);
            });

        //Et cette tache prend un rang
        await this.$axios.put('nonFact/' + tache._id, {rank: actualRank + 1})
          .then(response => {
              console.log(response.data.message);
              this.nonFact[actualRank].rank = actualRank + 1;
            })
            .catch(e => {
              console.log(e);
            });
        

        //Pour finir, je range le client dans l'ordre
        this.nonFact.sort((a,b) => (a.rank > b.rank) ? 1 : ((b.rank > a.rank) ? -1 : 0));


      //Si on cherche à la faire monter et qu'elle n'est pas déjà la première
      } else if (sens < 0   &&   tache.rank > 0){
        //La tache précedente prend un rang, donc vient au rang actuel
        await this.$axios.put('nonFact/' + this.nonFact[actualRank - 1]._id, {rank: actualRank})
          .then(response => {
              console.log(response.data.message);
              //Je met à jour la tache dans this.nonFact du client
              this.nonFact[actualRank - 1].rank = actualRank;
            })
            .catch(e => {
              console.log(e);
            });

        //Et cette tache perd un rang
        await this.$axios.put('nonFact/' + tache._id, {rank: actualRank - 1})
          .then(response => {
              console.log(response.data.message);
              this.nonFact[actualRank].rank = actualRank - 1;
            })
            .catch(e => {
              console.log(e);
            });
        

        //Pour finir, je range le client dans l'ordre
        this.nonFact.sort((a,b) => (a.rank > b.rank) ? 1 : ((b.rank > a.rank) ? -1 : 0));
      }
    },
    changeTache(newName, tacheId){
      this.$axios.put('nonFact/' + tacheId, {name: newName})
          .then(response => {
              console.log(response.data.message);
            })
    },
    deleteTache(_Id){
      this.$axios.put('nonFact/flagDeleted/' + _Id + '/' + this.$store.state.auth.currentAgence._id)
      .then(response => {
        console.log(response.data.message);
        this.nonFact.splice(this.nonFact.findIndex(e => e._id == _Id), 1)
        this.closeModaleDelete()
      })
    },


    //-------------------------------
    //           Absences
    //-------------------------------
     addAbsence(payload){
      //Vérifier qu'il y a bien une ID d'agence dans le local store, sinon je ne saurai pas à quelle agence relier cette nouvelle tache.
      //Vérifier qu'il y ai bien une nouvelle valeur à ajouter

      if (this.$store.state.auth.currentAgence._id  &&  payload[0] != ""){
        //Je commence par calculer à quel rang je place la future tache par rapport à la plus grande tache existante, si elle existe
        let actualRank
        if (this.absences.length > 0){
          actualRank = this.absences.length - 1  
        } else {
          actualRank = -1
        }      

        //Je défini ma nonFact
        let absence = {
          agenceId: this.$store.state.auth.currentAgence._id,
          name: payload[0],
          rank: actualRank + 1,
        };

        this.$axios.post('absences/register', absence)
        .then(response => {
          console.log(response.data.message)
          //J'ajoute l'Id reçu de serveur à mon objet tache en local pour l'ajouter à mon client et pouvoir la manipuler
          absence._id = response.data.absenceId;
          this.absences.push(absence);
        })
        .catch(e => {
          console.log(e);
        });

      } else {
        console.log("Pas d'ID d'agence en local, impossible de savoir à quelle ID relier ces nouvelles données.")
      }
    },
    async moveAbsence(tache, sens){
      //Si on cherche à faire descendre la tache (le rang augmente) et qu'elle n'est pas déjà la dernière
      let actualRank = tache.rank;
      if (sens > 0   &&   tache.rank < this.absences.length -1){
        //La tache suivante perd un rang, donc vient au rang actuel
        await this.$axios.put('absences/' + this.absences[actualRank + 1]._id, {rank: actualRank})
          .then(response => {
              console.log(response.data.message);
              //Je met à jour la tache dans this.nonFact du client
              this.absences[actualRank + 1].rank = actualRank;
            })
            .catch(e => {
              console.log(e);
            });

        //Et cette tache prend un rang
        await this.$axios.put('absences/' + tache._id, {rank: actualRank + 1})
          .then(response => {
              console.log(response.data.message);
              this.absences[actualRank].rank = actualRank + 1;
            })
            .catch(e => {
              console.log(e);
            });
        

        //Pour finir, je range le client dans l'ordre
        this.absences.sort((a,b) => (a.rank > b.rank) ? 1 : ((b.rank > a.rank) ? -1 : 0));


      //Si on cherche à la faire monter et qu'elle n'est pas déjà la première
      } else if (sens < 0   &&   tache.rank > 0){
        //La tache précedente prend un rang, donc vient au rang actuel
        await this.$axios.put('absences/' + this.absences[actualRank - 1]._id, {rank: actualRank})
          .then(response => {
              console.log(response.data.message);
              //Je met à jour la tache dans this.nonFact du client
              this.absences[actualRank - 1].rank = actualRank;
            })
            .catch(e => {
              console.log(e);
            });

        //Et cette tache perd un rang
        await this.$axios.put('absences/' + tache._id, {rank: actualRank - 1})
          .then(response => {
              console.log(response.data.message);
              this.absences[actualRank].rank = actualRank - 1;
            })
            .catch(e => {
              console.log(e);
            });
        

        //Pour finir, je range le client dans l'ordre
        this.absences.sort((a,b) => (a.rank > b.rank) ? 1 : ((b.rank > a.rank) ? -1 : 0));
      }
    },
    changeAbsence(newName, tacheId){
      this.$axios.put('absences/' + tacheId, {name: newName})
          .then(response => {
              console.log(response.data.message);
            })
    },
    deleteAbsence(_Id){
      this.$axios.put('absences/flagDeleted/' + _Id + '/' + this.$store.state.auth.currentAgence._id)
      .then(response => {
        console.log(response.data.message);
        this.absences.splice(this.absences.findIndex(e => e._id == _Id), 1)
        this.closeModaleDelete()
      })
    },

    //-------------------------------
    //           Frais
    //-------------------------------
     addFrais(payload){
      //Vérifier qu'il y a bien une ID d'agence dans le local store, sinon je ne saurai pas à quelle agence relier cette nouvelle tache.
      //Vérifier qu'il y ai bien une nouvelle valeur à ajouter

      if (this.$store.state.auth.currentAgence._id  &&  payload[0] != ""){
        //Je commence par calculer à quel rang je place la future tache par rapport à la plus grande tache existante, si elle existe
        let actualRank
        if (this.frais.length > 0){
          actualRank = this.frais.length - 1  
        } else {
          actualRank = -1
        }      

        //Je défini mon item
        let fraisItem = {
          agenceId: this.$store.state.auth.currentAgence._id,
          name: payload[0],
          rank: actualRank + 1,
        };

        this.$axios.post('frais/register', fraisItem)
        .then(response => {
          console.log(response.data.message)
          //J'ajoute l'Id reçu de serveur à mon objet tache en local pour l'ajouter à mon client et pouvoir la manipuler
          fraisItem._id = response.data.fraisId;
          this.frais.push(fraisItem);
        })
        .catch(e => {
          console.log(e);
        });

      } else {
        console.log("Pas d'ID de frais en local, impossible de savoir à quelle ID relier ces nouvelles données.")
      }
    },
    async moveFrais(tache, sens){
      //Si on cherche à faire descendre la tache (le rang augmente) et qu'elle n'est pas déjà la dernière
      let actualRank = tache.rank;
      if (sens > 0   &&   tache.rank < this.frais.length -1){
        //La tache suivante perd un rang, donc vient au rang actuel
        await this.$axios.put('frais/' + this.frais[actualRank + 1]._id, {rank: actualRank})
          .then(response => {
              console.log(response.data.message);
              //Je met à jour la tache dans this.nonFact du client
              this.frais[actualRank + 1].rank = actualRank;
            })
            .catch(e => {
              console.log(e);
            });

        //Et cette tache prend un rang
        await this.$axios.put('frais/' + tache._id, {rank: actualRank + 1})
          .then(response => {
              console.log(response.data.message);
              this.frais[actualRank].rank = actualRank + 1;
            })
            .catch(e => {
              console.log(e);
            });
        

        //Pour finir, je range le client dans l'ordre
        this.frais.sort((a,b) => (a.rank > b.rank) ? 1 : ((b.rank > a.rank) ? -1 : 0));


      //Si on cherche à la faire monter et qu'elle n'est pas déjà la première
      } else if (sens < 0   &&   tache.rank > 0){
        //La tache précedente prend un rang, donc vient au rang actuel
        await this.$axios.put('frais/' + this.frais[actualRank - 1]._id, {rank: actualRank})
          .then(response => {
              console.log(response.data.message);
              //Je met à jour la tache dans this.nonFact du client
              this.frais[actualRank - 1].rank = actualRank;
            })
            .catch(e => {
              console.log(e);
            });

        //Et cette tache perd un rang
        await this.$axios.put('frais/' + tache._id, {rank: actualRank - 1})
          .then(response => {
              console.log(response.data.message);
              this.frais[actualRank].rank = actualRank - 1;
            })
            .catch(e => {
              console.log(e);
            });
        

        //Pour finir, je range le client dans l'ordre
        this.frais.sort((a,b) => (a.rank > b.rank) ? 1 : ((b.rank > a.rank) ? -1 : 0));
      }
    },
    changeFrais(newName, tacheId){
      this.$axios.put('frais/' + tacheId, {name: newName})
          .then(response => {
              console.log(response.data.message);
            })
    },
    deleteFrais(_Id){
      this.$axios.put('frais/flagDeleted/' + _Id)
      .then(response => {
        console.log(response.data.message);
        this.frais.splice(this.frais.findIndex(e => e._id == _Id), 1)
        this.closeModaleDelete()
      })
    },
  },
}
</script>


<template>
    <div style="width: 700px;">
        <!-- Modale de suppression d'un item d'une liste -->
        <Modale v-if="isModaleVisible_delete" @close="closeModaleDelete">
          <template v-slot:header>
            <span>{{modaleInfos.title}}</span>
          </template>
          <template v-slot:body>
            <p>Cet élément sera supprimé et ne pourra plus être utilisé. Toutefois, les saisies antérieures associées à cet élément seront conservées.</p>
          </template>
          <template v-slot:footer>
            <ModalYesNo v-if="modaleInfos.type == 'phase'"        @no="closeModaleDelete" @yes="deletePhase(modaleInfos._id)"></ModalYesNo>
            <ModalYesNo v-else-if="modaleInfos.type == 'tache'"   @no="closeModaleDelete" @yes="deleteTache(modaleInfos._id)"></ModalYesNo>
            <ModalYesNo v-else-if="modaleInfos.type == 'absence'" @no="closeModaleDelete" @yes="deleteAbsence(modaleInfos._id)"></ModalYesNo>
            <ModalYesNo v-else-if="modaleInfos.type == 'frais'"   @no="closeModaleDelete" @yes="deleteFrais(modaleInfos._id)"></ModalYesNo>
          </template>

        </Modale>

        <Section text="Phases par défaut" class="section">
          <template v-slot:body>
            <div class="content">
              <div class="content__text">
                La liste des phases par défaut pour les projets facturables. Chaque projet pourra sélectionner une ou plusieurs phases parmis celles-ci, et contenir des phases spécifiques complémentaires.
              </div>
              <div class="content__multi">
                <div class="content__list" v-for="(type, index) in phases" :key="type._id">
                  <!-- Titre -->
                  <div class="content__list__title" v-if="index == 0">Phases d'études</div>
                  <div class="content__list__title" v-if="index == 1">Phases de chantier</div>
                  <div class="content__list__title" v-if="index == 2">Mission complémentaires</div>
                  <transition-group name="list">
                    <div class="content__list__line" v-for="phase in phases[index]" :key="phase._id">
                      <span class="material-icons" @click="movePhase(phase, index,-1)">expand_less</span>
                      <span class="material-icons" @click="movePhase(phase, index, 1)">expand_more</span>
                      <input type="text" v-model="phase.name" @change="changePhase(phase.name,phase._id)"/>
                      <span class="material-icons" @click="showModaleDelete('phase', phase._id)">delete_outline</span>
                    </div>
                  </transition-group>
                  <Ajouter label="Ajouter une phase" labelSize=12 icon="add_circle" @submit="addPhase($event, index)" :formIndex="index" class="content__list__ajouter"  />
                </div>
              </div>
            </div>
          </template>
        </Section>

        <Section text="Tâches non facturables" class="section">
          <template v-slot:body>
            <div class="content">
              <div class="content__text">
                L'ensemble des éléments sur lesquels vous êtes amenés à passer du temps, mais qui ne donnent pas lieu à une facturation. Par exemple, le suivi administratif, la gestion informatique, la prospection, etc.
              </div>
              <div class="content__list">
                <transition-group name="list">
                  <div class="content__list__line" v-for="tache in nonFact" :key="tache._id">
                    <span class="material-icons" @click="moveTache(tache,-1)">expand_less</span>
                    <span class="material-icons" @click="moveTache(tache, 1)">expand_more</span>
                    <input type="text" v-model="tache.name" @change="changeTache(tache.name,tache._id)"/>
                    <span class="material-icons" @click="showModaleDelete('tache', tache._id)">delete_outline</span>
                  </div>
                </transition-group>
                <Ajouter label="Ajouter une tâche" labelSize=12 icon="add_circle" @submit="addTache($event)" class="content__list__ajouter" formIndex="taches" />
              </div>
            </div>
          </template>
        </Section>

        <Section text="Abscences & congés">
          <template v-slot:body>
            <div class="content">
              <div class="content__text">
                Les différents types d'absences possibles.
              </div>
              <div class="content__list">
                <transition-group name="list">
                  <div class="content__list__line" v-for="absence in absences" :key="absence._id">
                    <span class="material-icons" @click="moveAbsence(absence,-1)">expand_less</span>
                    <span class="material-icons" @click="moveAbsence(absence, 1)">expand_more</span>
                    <input type="text" v-model="absence.name" @change="changeAbsence(absence.name, absence._id)"/>
                    <span class="material-icons" @click="showModaleDelete('absence', absence._id)">delete_outline</span>
                  </div>
                </transition-group>
                <Ajouter label="Ajouter une absence" labelSize=12 icon="add_circle" @submit="addAbsence($event)" class="content__list__ajouter" formIndex="absences" />
              </div>
            </div>
          </template>
        </Section>

        <Section text="Frais spécifiques à un projet">
          <template v-slot:body>
            <div class="content">
              <div class="content__text">
                L'ensemble des frais que peut générer un projet. Qu'il s'agisse de la sous-traitance à un bureau d'étude, de l'impression de documents, de déplacements ou de repas.
                <p>Ces éléments seront utilisés pour répartir les différents types de prestations extérieures et de notes de frais. Ils sont communs aux deux, car un même type de frais peut être payé directement par l'agence, ou par le salarié via une note de frais (ex: impressions, billets de train, etc.).</p>
                
              </div>
              <div class="content__list">
                <transition-group name="list">
                  <div class="content__list__line" v-for="item in frais" :key="item._id">
                    <span class="material-icons" @click="moveFrais(item,-1)">expand_less</span>
                    <span class="material-icons" @click="moveFrais(item, 1)">expand_more</span>
                    <input type="text" v-model="item.name" @change="changeFrais(item.name, item._id)"/>
                    <span class="material-icons" @click="showModaleDelete('frais', item._id)">delete_outline</span>
                  </div>
                </transition-group>
                <Ajouter label="Ajouter un frais" labelSize=12 icon="add_circle" @submit="addFrais($event)" class="content__list__ajouter" formIndex="frais" />
              </div>
            </div>
          </template>
        </Section>
    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';

.section{
  margin: 0 0 30px 0;
}

.content{
  display: flex;
  justify-content: space-between;

  &__text{
    @include myFont;
    font-size: 14px;
    width: 400px;
    padding: 0 20px 0 0;
  }

  &__multi{
    display: flex;
    flex-direction: column;
  }

  &__list{
    display: flex;
    flex-direction: column;
    margin: 0 0 25px 0;

    &__title{
      color: $main;
      @include myFont;
      font-weight: 600;
      margin: 0 0 10px 0;
    }

    &__line{
      @include myBlock;
      display: flex;
      align-items: center;
      margin: 3px 0 0 0;
      // background-color: $main-UltraLight;
      padding: 4px;

      & input{
        border: none;
        border-bottom: 1px solid $main;
        width: 200px;
        margin: 0 15px 3px 15px;
        background-color: rgba(0,0,0,0);
        @include myFont;
      }

      & span{
        color: $mainBlack;
        font-size: 20px;

        &:hover{
          color: $color2;
          cursor: pointer;
        }
      }
    }

    &__ajouter{
      margin: 15px 0 0 0;
      flex: 1;
    }
  }
}

.list-move {
  transition: transform 0.5s;
}

</style>
